import { useEffect, useState } from 'react'

export function useMinWidth(px: number) {
  const [matches, setMatches] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(`(min-width: ${px}px)`).matches
  )
  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${px}px)`)
    const update = () => setMatches(mql.matches)
    update()
    mql.addEventListener('change', update)
    return () => mql.removeEventListener('change', update)
  }, [px])
  return matches
}
